import { render, staticRenderFns } from "./AsignacionesHistorialTabContent.vue?vue&type=template&id=513891ba&scoped=true"
import script from "./AsignacionesHistorialTabContent.vue?vue&type=script&lang=js"
export * from "./AsignacionesHistorialTabContent.vue?vue&type=script&lang=js"
import style0 from "./AsignacionesHistorialTabContent.vue?vue&type=style&index=0&id=513891ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513891ba",
  null
  
)

export default component.exports